import React from "react";
import Chart from "react-apexcharts";
import H5 from "../Typography/H5";
import { mergeBarChartOptions } from "../../pages/Compare/chartTheme";

const GrossNetProfitGrowth: React.FC<any> = ({ data }): React.ReactElement => {
  const { series = [], categories = [] } = data || {};

  const chartData: any = {
    options: mergeBarChartOptions({
      chart: {
        id: "GrossNetProfitGrowth",
      },
      xaxis: {
        categories,
      },
      tooltip: {
        shared: true,
        intersect: false,
        hideEmptySeries: false,
      },
      dataLabels: {
        enabled: true,
        offsetY: -20,
        formatter: (value: string) => {
          return Number(value).toFixed(2) + "%";
        },
      },
      yaxis: {
        labels: {
          formatter: (value: any) => {
            return `${value}%`;
          },
        },
      },
    }),
    chart: {
      type: "bar",
    },
    series,
  };

  return (
    <div className="flex w-full flex-col p-4 vi-glass-card">
      <H5 color="text-[color:var(--vi-text)]">Gross Profit Growth &amp; Net Profit Growth: Current vs Past</H5>
      <Chart
        options={chartData.options}
        series={chartData.series}
        type="bar"
        height={550}
      />
    </div>
  );
};

export default GrossNetProfitGrowth;
